import { SUCCESS_MESSAGES } from '@/enums/success-messages';

// eslint-disable-next-line
export const notifyDeleteUser = {
  methods: {
    openDeleteDealerDialog(user) {
      Promise.all([
        this.$root.$confirmationDialog.open(`Chcete obchodníka ${user.fullName} opravdu odstranit?`, null),
      ]).then((resolve) => {
        if (resolve[0]) {
          this.confirmUserDeleteAction(user);
        }
      });
    },
    notifyDeleteUser(user) {
      this.$notify.success({
        title: SUCCESS_MESSAGES.userDeleteSuccessMessage(
          user.firstName,
          user.lastName,
        ),
        showClose: true,
        type: 'success',
      });
    },
  },
};
